// 45 seconds in milliseconds
export const MAXIMUM_TIP_WAIT_TIME = 45 * 1000;
